module.exports = __webpack_public_path__ + "img/load.c49d969e.svg";